import icon1 from "../../assets/track_icons/icon1.webp";
import icon2 from "../../assets/track_icons/icon2.webp";
import icon3 from "../../assets/track_icons/icon3.webp";
import icon4 from "../../assets/track_icons/icon4.webp";
import icon5 from "../../assets/track_icons/icon5.webp";
import icon6 from "../../assets/track_icons/icon6.webp";
import icon7 from "../../assets/track_icons/icon7.webp";
import icon8 from "../../assets/track_icons/icon8.webp";
import icon9 from "../../assets/track_icons/icon9.webp";
import icon10 from "../../assets/track_icons/icon10.webp";
import icon11 from "../../assets/track_icons/icon11.webp";
import icon12 from "../../assets/track_icons/icon12.webp";
import icon13 from "../../assets/track_icons/icon13.webp";
import icon14 from "../../assets/track_icons/icon14.webp";
import icon15 from "../../assets/track_icons/icon15.webp";
import icon16 from "../../assets/track_icons/icon16.webp";
import icon17 from "../../assets/track_icons/icon17.webp";
import icon18 from "../../assets/track_icons/icon18.webp";
import icon19 from "../../assets/track_icons/icon19.webp";
import icon20 from "../../assets/track_icons/icon20.webp";
export const tracks = [
  { name: "Paradigms of Regenerative Agriculture", icon: icon1  },
  { name: "Carbon, Microbes & Nutrient Cycling", icon:  icon2},
  { name: "Agroecology", icon:  icon3 },
  { name: "Biodiversity", icon: icon4 },
  { name: "Precision Agriculture for Regenerative Farming", icon:   icon5},
  { name: "AI, Remote Sensing & GIS for Soil, Crops", icon :icon6 },
  { name: "IoT & Sensor Networks for Regenerative Farming", icon:  icon7 },
  { name: "Robotics & Automation for Low-Impact Farming", icon:icon8 },
  { name: "Carbon Sequestration", icon:icon9},
  { name: "MRV Tools & Climate-Smart Agriculture", icon:icon10},
  { name: "Biochar, Composting & Biological Amendments", icon:icon11 },
  { name: "Micro-Catchments, Drip Optimisations & Hydrology Mapping", icon: icon12 },
  { name: "Plant–Microbiome Engineering", icon:icon13 },
  { name: "Biofertilisers, Biostimulants & Mycorrhizal Innovations", icon: icon14},
  { name: "Regenerative Pest Management", icon:icon15 },
  { name: "Regenerative Horticulture, Agroforestry & Polyculture Systems", icon:icon16 },
  { name: "Livestock Integration, Holistic Grazing & Manure Circularity", icon: icon17 },
  { name: "Waste-to-Value Innovations in Farms", icon: icon18 },
   { name: "Regenerative Supply Chains & Market Incentives", icon: icon19 },
  { name: "Certification Frameworks for Regenerative Farming", icon: icon20 },

];
